module.exports = __webpack_public_path__ + "img/shentianlan.7a0685e8.png";